import { OneOfFeeSpacePeriodPackagePriceOffice } from '@/entities/oneOfFeeSpacePeriodPackagePriceOffice.ts'

export const state = () => ({
  oneOfFeeSpacePeriodPackagePriceOffice: new OneOfFeeSpacePeriodPackagePriceOffice(),
})

export const getters = {
  getOneOfFeeSpacePeriodPackagePriceOffice: (state) => {
    return state.oneOfFeeSpacePeriodPackagePriceOffice
  },
}

export const mutations = {
  SET_ONE_OF_FEE_SPACE_PERIOD_PACKAGE_PRICE_OFFICE: (state, payload) => {
    state.oneOfFeeSpacePeriodPackagePriceOffice = payload
  },
}

export const actions = {
  setOneOfFeeSpacePeriodPackagePriceOffice({ commit }, payload) {
    commit('SET_ONE_OF_FEE_SPACE_PERIOD_PACKAGE_PRICE_OFFICE', payload)
  },

  async getOneOfFeeSpacePeriodPackagePriceOfficeById({ commit }, id) {
    const r = await this.$axios.$get(
      `/one-of-fee-space-period-package-price-office/${id}`
    )
    if (!r || !r.data) {
      throw new Error(
        'error in response format: oneOfFeeSpacePeriodPackagePriceOffice'
      )
    }
    commit('SET_ONE_OF_FEE_SPACE_PERIOD_PACKAGE_PRICE_OFFICE', r.data)
  },

  async createOneOfFeeSpacePeriodPackagePriceOffice(
    { commit, getters },
    payload
  ) {
    if (payload) {
      commit('SET_ONE_OF_FEE_SPACE_PERIOD_PACKAGE_PRICE_OFFICE', payload)
    }
    const r = await this.$axios.$post(
      `/one-of-fee-space-period-package-price-office`,
      getters.getOneOfFeeSpacePeriodPackagePriceOffice
    )
    if (!r || !r.data) {
      throw new Error(
        'error in response format on creating: oneOfFeeSpacePeriodPackagePriceOffice'
      )
    }
    commit('SET_ONE_OF_FEE_SPACE_PERIOD_PACKAGE_PRICE_OFFICE', r.data)
  },

  async saveOneOfFeeSpacePeriodPackagePriceOffice(
    { commit, getters },
    payload
  ) {
    if (payload) {
      commit('SET_ONE_OF_FEE_SPACE_PERIOD_PACKAGE_PRICE_OFFICE', payload)
    }
    const r = await this.$axios.$put(
      `/one-of-fee-space-period-package-price-office/${getters.getOneOfFeeSpacePeriodPackagePriceOffice.id}`,
      getters.getOneOfFeeSpacePeriodPackagePriceOffice
    )
    if (!r || !r.data) {
      throw new Error(
        'error in response format on saving: oneOfFeeSpacePeriodPackagePriceOffice'
      )
    }
    commit('SET_ONE_OF_FEE_SPACE_PERIOD_PACKAGE_PRICE_OFFICE', r.data)
  },

  async deleteOneOfFeeSpacePeriodPackagePriceOffice(
    { commit, getters },
    payload
  ) {
    if (payload) {
      commit('SET_ONE_OF_FEE_SPACE_PERIOD_PACKAGE_PRICE_OFFICE', payload)
    }
    await this.$axios.$delete(
      `/one-of-fee-space-period-package-price-office/${getters.getOneOfFeeSpacePeriodPackagePriceOffice.id}`
    )
    commit('SET_ONE_OF_FEE_SPACE_PERIOD_PACKAGE_PRICE_OFFICE', null)
  },
}
